import { queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import NotificationsButtonQuery, {
	type NotificationsButtonQuery$data,
	type NotificationsButtonQuery$variables,
} from './__generated__/NotificationsButtonQuery.graphql.ts';

export const preloadUnseenNotificationCount = () => {
	return queryAgg<NotificationsButtonQuery$data, NotificationsButtonQuery$variables>({
		query: NotificationsButtonQuery,
	});
};
